import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { CompanyForm } from "../../components/company/CompanyForm";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import type { Company } from "../../models/company";
import { companies_path, company_path } from "../../routes";

type CompanyProps = {
  company: Company;
};

export default function CompanyEdit({ company }: CompanyProps) {
  const { pathWithYearContext } = useYearContext();
  const updateCompany = (name: RequestPayload) => router.put(pathWithYearContext(company_path, company.id), name);

  return (
    <ContentShell title={`Lehrbetrieb ${company.name}`} onBack={() => router.get(pathWithYearContext(companies_path))}>
      <CompanyForm company={company} onSubmit={updateCompany} submitButtonLabel="Speichern" />
    </ContentShell>
  );
}
